
import React from 'react'

import { Stack, Typography } from '@mui/material'

import { MenuButton } from '@repo/ui'


interface RowsPerPageSelectorProps {
  apiRef: any,
  before?: React.ReactNode
  after?: React.ReactNode
  options?: PageSizeOption[]
  page?: number
  pageCount?: number
  pageSize?: number
  defaultValue?: number
}

type PageSizeOption = {
  value: number
  label: string
}

const DEFAULT_OPTIONS: PageSizeOption[] = [
  { value: 25, label: '25' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
  { value: -1, label: 'All'}
]

export const RowsPerPageSelector = (props: RowsPerPageSelectorProps) => {
  const { 
    options = DEFAULT_OPTIONS, 
    pageSize = 10, 
    pageCount, 
    page, 
    defaultValue = 10, 
    apiRef 
  } = props
  
  const handleChange = (pageSize: number) => {
      apiRef.current.setPageSize(pageSize)
  }
  return (
    <Stack 
      direction="row" 
      spacing={2} 
      alignItems="center"
      display="flex" 
      sx={{p: 2, pl: 4}}>
      <Typography variant="body3" color="text.secondary">
        Rows per page
      </Typography>
      <MenuButton
        size="small"
        dense
        items={options}
        selected={{label: String(pageSize), value: pageSize}}
        variant='tertiary'
        onSelect={(item) => handleChange(item.value)}
        // Open upward (drop-up): pin the menu's bottom-left to the trigger's top-left.
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        // The trigger/menu gap is owned by MenuButton's paper, which flips the
        // margin's sign for a drop-up. (An `mb` here would land on the Menu ROOT —
        // a fixed, full-viewport container — and do nothing.)
        buttonProps={{
          sx: {
            // Match the table cell font size (Table.tsx StyledDataGrid: fontSize 14),
            // so the page-size value doesn't read larger/smaller than the rows above it.
            fontSize: 14,
            px: 1,
            pl: 1.5,
          }
        }}
      />
  </Stack>
  )
}
